import {
  MERGE_COLLABORATORS,
  MERGE_ASSIGNEES,
  MERGE_CREATOR,
  MERGE_USER,
  MERGE_CONTACT,
  MERGE_DESCRIPTION,
  MERGE_DUE_DATE,
  MERGE_PROJECT,
  MERGE_STATUS,
  MERGE_TAGS,
  MERGE_NAME,
} from "@avenueops/shared-types";

interface Props {
  fullFieldName: string;
}

export function getMergeFieldDescription(fullFieldName: string): JSX.Element | null {
  switch (fullFieldName) {
    case MERGE_COLLABORATORS:
      return null;
    case MERGE_ASSIGNEES:
      return <span>The user this ticket is assigned to</span>;
    case MERGE_CREATOR:
      return <span>The user who created this ticket</span>;
    case MERGE_USER:
      return null;
    case MERGE_CONTACT:
      return <span>The contact associated with the ticket</span>;
    case MERGE_NAME:
      return <span>The ticket title. If absent, the signal title will be used as the ticket title</span>;
    case MERGE_DESCRIPTION:
      return (
        <span>
          The ticket description. HTML version of description is mapped if supported by the third-party platform. If absent, the signal body will be used as the
          ticket description
        </span>
      );
    case MERGE_DUE_DATE:
      return <span>The ticket's due date</span>;
    case MERGE_PROJECT:
      return <span>The project the ticket belongs to</span>;
    case MERGE_STATUS:
      return (
        <span>
          The current status of the ticket. Must pass in one of the following choices:{" "}
          <strong>
            <code>OPEN, CLOSED, IN_PROGRESS, ON_HOLD</code>
          </strong>
          , or, if available, select a status from the provided options
        </span>
      );
    case MERGE_TAGS:
      return (
        <span>
          The list of available tags for the ticket, <strong>or</strong> enter in a tag name if it cannot be found through the selector
        </span>
      );
    default:
      return null;
  }
}
